import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { mapParamsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TbmEntry_BASIC_Schema } from './M_TbmEntry_BASIC_Schema';
import { handleQuerySuccess } from '../../../../Hooks/apis/useQuriesSuccess';

/** 마지막으로 저장한 부서(소속) 조회 getTbmNewR11 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(M_TbmEntry_BASIC_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['ToolBoxMeeting', 'getTbmNewR11', params],
    queryFn: () =>
      apiRequest('post', Global.urls.ToolBoxMeeting.getTbmNewR11, params),
    enabled: true,
    // 캐시를 재사용하지 않고 마운트마다 항상 새로 조회(직전 TBM 저장 직후 다시 시작해도 최신값을 받도록)
    gcTime: 0,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};
